import React, { useState, useEffect, useRef } from "react";

import api from "../../services/api";
import validadorCpfCnpj from "../../services/validadorCpfCnpj";
import { store } from "react-notifications-component";

import Search from "../../components/search";
import HeaderV2 from "../../components/headerV2";
import Button from "../../components/button/button_v2";
import InputV3 from "../../components/input/novo/input_v3";
import ModalAlert from "../../components/modal/modalGeneric";
import HistoryList from "../../components/historico/history-list";
import FilterHistory from "../../components/historico/filter-history";
import ModalExportar from "../../components/modal/modalHistoricoExportar";

import ItemNotFound from "../../assets/img-undraw-search.svg";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
// import SetaBranca from "../../assets/icons/icon-right-circle-white.png";

import * as S from "./styles";
import { theme } from "../../styles/theme";

import Filter from "../../assets/icons/icon-Tune.png";
  import ModalImageRecursoCliente from "../../assets/modalRecursoClientes.svg";
import Modal from "../../components/modal/modalGenericV2";
import { Auxiliar, BodyG, H5, H6, TaglineM } from "../../styles/stylesTypography";
import Paginator from "../../components/paginator";
import PaginatorV2 from "../../components/paginator/indexV2";

export const USER = "@userinfo";

const Historico = ({ ...props }) => {
  // Suporte a chegar aqui já filtrado por ART/TRT (ex.: "Ver receitas
  // emitidas" na tela de ARTs/TRT manda pra /historico?art_id=123). O valor
  // do filtro "ART/TRT" é o id da ART (agro_art_id), não o número dela.
  const presetArtFilter = React.useMemo(() => {
    try {
      const params = new URLSearchParams(props.location?.search || "");
      const artId = params.get("art_id");
      if (!artId) return null;
      const parsed = Number(artId);
      return Number.isFinite(parsed) ? { "ART/TRT": [parsed] } : null;
    } catch (error) {
      return null;
    }
  }, [props.location?.search]);

  const [history, setHistory] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [filters, setFilters] = useState({});
  const [selectedFilters, setSelectedFilters] = useState(() => presetArtFilter || {});
  const [showModalGuide, setShowModalGuide] = useState(false);
  const [aplicadores, setAplicadores] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [aplicadorOptions, setAplicadorOptions] = useState([]);
  const [prestadorOptions, setPrestadorOptions] = useState([]);
  const [selectedAplicador, setSelectedAplicador] = useState(null);
  const [selectedPrestador, setSelectedPrestador] = useState(null);
  const [dataAplicacao, setDataAplicacao] = useState("");
  const [selectedPrescriptionId, setSelectedPrescriptionId] = useState(null);
  const [selectedReceitaGuia, setSelectedReceitaGuia] = useState(null);
  const [addAplicador, setAddAplicador] = useState(false);
  const [addPrestador, setAddPrestador] = useState(false);
  const [newNameAplicador, setNewNameAplicador] = useState("");
  const [newCPFAplicador, setNewCPFAplicador] = useState("");
  const [aplicadorError, setAplicadorError] = useState(false);
  const [aplicadorErrorMsg, setAplicadorErrorMsg] = useState('Campo obrigatório!');
  const [newNamePrestador, setNewNamePrestador] = useState("");
  const [newCNPJPrestador, setNewCNPJPrestador] = useState("");
  const [prestadorError, setPrestadorError] = useState(false);
  const [prestadorErrorMsg, setPrestadorErrorMsg] = useState('Campo obrigatório!');

  const [isAccordionOpen, setAccordionOpen] = useState(false);
  const [openModalExport, setOpenModalExport] = useState(false);
  const [relatoriosDisponiveis, setRelatoriosDisponiveis] = useState(null);

  const [showFilter, setShowFilter] = useState(false);
  const [optionTitle, setOptionTitle] = useState("");
  const [optionValue, setOptionValue] = useState("");
  const [filtroState, setFiltro] = useState("");

  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");

  const [limit, setLimit] = useState(30); // Ajuste conforme a necessidade
  const [offset, setOffset] = useState(0); // Começa na primeira página
  const [total, setTotal] = useState(0); // Total de itens retornados da API
  const [loadHistory, setLoadHistory] = useState(true);
  const [filtersLoading, setFiltersLoading] = useState(false);

  const [showModalBlock, setShowModalBlock] = useState(false);
  const [showModalGuiaPlanBlock, setShowModalGuiaPlanBlock] = useState(false);
  const [guiaPlanBlockInfo, setGuiaPlanBlockInfo] = useState({ planId: null, planName: "" });

  const exportOptions = [
    relatoriosDisponiveis?.BA ? { estado: "BA", label: "ADAB", option: 7 } : null,
    relatoriosDisponiveis?.PR ? { estado: "PR", label: "SIAGRO", option: 1 } : null,
    relatoriosDisponiveis?.RS ? { estado: "RS", label: "SDA RS", option: 5 } : null,
    relatoriosDisponiveis?.MG ? { estado: "MG", label: "SICCA", option: 8 } : null,
  ].filter(Boolean);

  const hasExportOptions = exportOptions.length > 0;

  const toggleAccordion = () => {
    if (!hasExportOptions) return;
    setAccordionOpen(!isAccordionOpen);
  };

  const accordionRef = useRef(null);

  const [showModalNotification, setShowModalNotification] = useState(false);
  const [showModalNotificationMG, setShowModalNotificationMG] = useState(false);

  const getNotificacoes = async () => {
        try {
            const response = await api.get('/sidago/notificacao');

            if (response.data.status === false) {
                setShowModalNotification(true);
            }
        } catch (error) {}
    }

    const getNotificacoesMG = async () => {
        try {
            const response = await api.get('/sicca/notificacao');

            if (response.data.status === false) {
                setShowModalNotificationMG(true);
            }
        } catch (error) {}
    }

  useEffect(() => {
      getNotificacoes();
      getNotificacoesMG();
  }, []);

  const handleClickOutside = (event) => {
    if (accordionRef.current && !accordionRef.current.contains(event.target)) {
      setAccordionOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const removeAccents = (str) => {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  const buildPayload = () => {
    return {
      search: searchTerm ? searchTerm : "",
      agronomos: selectedFilters["Responsável Técnico"] || [],
      art_trt: selectedFilters["ART/TRT"] || [],
      produtores: selectedFilters["Produtor"] || [],
      fazendas: selectedFilters["Fazenda/Sítio"] || [],
      culturas: selectedFilters["Cultura"] || [],
      classes: selectedFilters["Classe"] || [],
      pragas: selectedFilters["Praga ou Alvo"] || [],
      fabricantes: selectedFilters["Fabricante"] || [],
      data_emissao: selectedFilters["Data de Emissão"] || [],
      date_begin: startDateFilter || "",
      date_end: endDateFilter || "",
      ocultar_canceladas: false,
    };
  };

  const formatArtFilterOptions = (filtersData) => {
    if (!filtersData || !Array.isArray(filtersData.art_trt)) {
      return filtersData;
    }

    const art_trt = filtersData.art_trt.map((item) => {
      const numeroArt = item?.numero_art || item?.label || "";
      const apelido = item?.apelido || "";
      const label = apelido && numeroArt ? `${numeroArt} - ${apelido}` : numeroArt;
      return {
        ...item,
        label: label || item?.label || "",
      };
    });

    return {
      ...filtersData,
      art_trt,
    };
  };

  const lastHistoryQueryKeyRef = useRef(null);
  const historyRequestSeqRef = useRef(0);

  const handleSelectedFiltersChange = (next) => {
    setSelectedFilters((prev) => {
      const prevKey = JSON.stringify(prev || {});
      const nextKey = JSON.stringify(next || {});
      if (prevKey === nextKey) return prev;
      return next || {};
    });
  };

  const getHistory = async ({ force } = {}) => {
    const payload = buildPayload();
    const queryKey = JSON.stringify({ limit, offset, payload });

    if (!force && queryKey === lastHistoryQueryKeyRef.current) {
      return;
    }

    lastHistoryQueryKeyRef.current = queryKey;
    const requestSeq = ++historyRequestSeqRef.current;

    setLoadHistory(true);

    try {
      setLoadHistory(true);
      const response = await api.post(
        "/receitas/historico?limit=" + limit + "&offset=" + offset,
        payload
      );
      if (requestSeq !== historyRequestSeqRef.current) return;

      if (response.data && response.data.data) {
        setHistory(response.data.data.prescriptions);
        setTotal(response.data.total);
      }
    } catch (error) {
      if (requestSeq !== historyRequestSeqRef.current) return;
      console.error("Erro ao buscar histórico:", error);
    } finally {
      if (requestSeq === historyRequestSeqRef.current) {
        setLoadHistory(false);
      }
    }
  };

  const getFilters = async () => {
    const payload = buildPayload();
    setFiltersLoading(true);
    try {
      const response = await api.post("/receitas/historico/filtros", payload);
      if (response.data?.data?.filters) {
        setFilters(formatArtFilterOptions(response.data.data.filters));
      }
    } catch (error) {
    } finally {
      setFiltersLoading(false);
    }
  };

  useEffect(() => {
    try {
      const flag = localStorage.getItem('receitaEmitida');
      if (flag === 'true' && total === 1) {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({ type: 'primeira_receita_emitida', source: 'web' })
          );
        }
        localStorage.removeItem('receitaEmitida');
      }
    } catch (e) {}
  }, [total]);

  const getAplicadores = async () => {
    try {
      const responseAplicadores = await api.get("/aplicador");
      if (responseAplicadores.data && responseAplicadores.data.data) {
        setAplicadores(responseAplicadores.data.data);
        const formattedAplicadores = responseAplicadores.data.data.map(
          (item) => ({
            value: item.id,
            label: item.name_applicator,
          })
        );
        setAplicadorOptions(formattedAplicadores);
      }

      const responsePrestadores = await api.get("/prestador");
      if (responsePrestadores.data && responsePrestadores.data.data) {
        setPrestadores(responsePrestadores.data.data);
        const formattedPrestadores = responsePrestadores.data.data.map(
          (item) => ({
            value: item.id,
            label: item.razao_social,
          })
        );
        setPrestadorOptions(formattedPrestadores);
      }
    } catch (error) {}
  };

  const criarGuiaAplicacao = async () => {
    if (
      !selectedAplicador ||
      !selectedPrestador ||
      !dataAplicacao ||
      !selectedPrescriptionId
    ) {
      store.addNotification({
        title: "Campos obrigatórios",
        message: "Preencha todos os campos antes de enviar.",
        type: "warning",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 3000, onScreen: true },
      });
      return;
    }
    const payload = {
      applicator_id: selectedAplicador.value,
      provider_id: selectedPrestador.value,
      data: dataAplicacao,
      p_relation_id: null,
      prescription_id: selectedPrescriptionId,
    };

    try {
      const response = await api.post("/guias", payload);

      window.open(response.data.link, "_blank");
      window.location.href = "/guia_aplicacao";

      store.addNotification({
        title: "Sucesso!",
        message: "Guia de aplicação criada com sucesso!",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, "ERRO-667 Erro ao criar guia de aplicação - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    } finally {
      setSelectedAplicador(null);
      setSelectedPrestador(null);
      setDataAplicacao("");
      setShowModalGuide(false);
    }
  };

  const formatCPF = (value) => {
    const numeric = value.replace(/\D/g, "").slice(0, 11);

    // Aplica a máscara conforme a quantidade de dígitos
    if (numeric.length <= 3) return numeric;
    if (numeric.length <= 6) return numeric.replace(/(\d{3})(\d+)/, "$1.$2");
    if (numeric.length <= 9)
      return numeric.replace(/(\d{3})(\d{3})(\d+)/, "$1.$2.$3");
    return numeric.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
  };

  const ValidateAplicador = (val) => {
    const formatted = formatCPF(val);
    setNewCPFAplicador(formatted);
  };

  const handleBlurAplicadorCpf = async () => {
    if (!newCPFAplicador.replace(/\D/g, '').trim()) return;

    const resultado = await validadorCpfCnpj(newCPFAplicador);
    if (!resultado.valido) {
      setAplicadorError(true);
      setAplicadorErrorMsg(resultado.erro || 'Informe um CPF válido.');
    } else {
      setAplicadorError(false);
      setAplicadorErrorMsg('Campo obrigatório!');
    }
  };

  const handleAddAplicador = async (name, cpf) => {
    if (!name || !cpf) {
      setAplicadorError(true);

      return;
    }

    const resultadoCpf = await validadorCpfCnpj(cpf);
    if (!resultadoCpf.valido) {
      setAplicadorError(true);
      store.addNotification({
        title: "Erro!",
        message: resultadoCpf.erro || "Informe um CPF válido.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    const payload = {
      nome_aplicador: name,
      cpf_aplicador: cpf,
    };
    try {
      const response = await api.post("/aplicador", payload);
      setAplicadores([...aplicadores, response.data.data]);
      const newAplicador = {
        value: response.data.data.id,
        label: response.data.data.name_applicator,
      };
      setAplicadorOptions([...aplicadorOptions, newAplicador]);
      setSelectedAplicador(newAplicador);
      setNewNameAplicador("");
      setNewCPFAplicador("");
      setAddAplicador(false);
      store.addNotification({
        title: "Sucesso!",
        message: "Aplicador adicionado com sucesso!",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, "ERRO-668 Erro ao adicionar aplicador - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    } finally {
      setAplicadorError(false);
    }
  };

  const formatCNPJ = (value) => {
    const numeric = value.replace(/\D/g, "").slice(0, 14);

    if (numeric.length <= 2) return numeric;
    if (numeric.length <= 5) return numeric.replace(/(\d{2})(\d+)/, "$1.$2");
    if (numeric.length <= 8)
      return numeric.replace(/(\d{2})(\d{3})(\d+)/, "$1.$2.$3");
    if (numeric.length <= 12)
      return numeric.replace(/(\d{2})(\d{3})(\d{3})(\d+)/, "$1.$2.$3/$4");
    return numeric.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/,
      "$1.$2.$3/$4-$5"
    );
  };

  const ValidatePrestador = (val) => {
    const formatted = formatCNPJ(val);
    setNewCNPJPrestador(formatted);
  };

  const handleBlurPrestadorCnpj = async () => {
    if (!newCNPJPrestador.replace(/\D/g, '').trim()) return;

    const resultado = await validadorCpfCnpj(newCNPJPrestador);
    if (!resultado.valido) {
      setPrestadorError(true);
      setPrestadorErrorMsg(resultado.erro || 'Informe um CNPJ válido.');
    } else {
      setPrestadorError(false);
      setPrestadorErrorMsg('Campo obrigatório!');
    }
  };

  const handleAddPrestador = async (name, cnpj) => {
    if (!name || !cnpj) {
      setPrestadorError(true);
      return;
    }

    const resultadoCnpj = await validadorCpfCnpj(cnpj);
    if (!resultadoCnpj.valido) {
      setPrestadorError(true);
      store.addNotification({
        title: "Erro!",
        message: resultadoCnpj.erro || "Informe um CNPJ válido.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    const payload = {
      razao_social: name,
      cnpj: cnpj,
    };

    try {
      const response = await api.post("/prestador", payload);

      const novoPrestador = {
        value: response.data.data.id,
        label: response.data.data.razao_social,
      };

      setPrestadores([...prestadores, response.data.data]);
      setPrestadorOptions([...prestadorOptions, novoPrestador]);
      setSelectedPrestador(novoPrestador);
      setNewNamePrestador("");
      setNewCNPJPrestador("");
      setAddPrestador(false);

      store.addNotification({
        title: "Sucesso!",
        message: "Prestador adicionado com sucesso!",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, "ERRO-669 Erro ao adicionar prestador - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    } finally {
      setPrestadorError(false);
    }
  };

  const openExport = async (option) => {
    let user = JSON.parse(localStorage.getItem(USER));

    if (user.contrato.agro_plan_config.is_teste === 1) {
      setShowModalBlock(true);
    } else {
      switch (option) {
        case 1:
          setOptionTitle("SIAGRO");
          setOptionValue(1);
          break;
        case 5:
          setOptionTitle("SDA RS");
          setOptionValue(5);
          break;
        case 7:
          setOptionTitle("ADAB");
          setOptionValue(7);
          break;
        case 8:
          setOptionTitle("SICCA");
          setOptionValue(8);
          break;
        default:
          break;
      }
      setOpenModalExport(true);
    }
  };

  const updateRespostaExportar = async (resposta) => {
    modalClose();
  };

  const modalClose = () => {
    if (showFilter === true) {
      setShowFilter(false);
    }

    if (openModalExport === true) {
      setOpenModalExport(false);
    }
  };

  const updateLimitOffset = (l, o) => {
    if (l !== limit || o !== offset) {
      setLimit(l);
      setOffset(o);
    }
  };

  const pushDataLayer = (event, payload = {}) => {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...payload });
    } catch (e) {}
  };

  const getUserFromStorage = () => {
    try {
      const raw = localStorage.getItem(USER);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  };

  const canUseGuiaAplicacao = (user) => {
    const isTeste = Number(user?.contrato?.agro_plan_config?.is_teste) === 1;
    const diasRestantes = Number(
      user?.contrato?.dias_restantes ?? user?.contrato?.dias_restante
    );

    if (isTeste && diasRestantes > 0) return true;

    const functions = user?.contrato?.agro_plan_functions;
    return (
      Array.isArray(functions) &&
      functions.some(
        (f) =>
          Number(f?.agro_plans_function?.id) === 11 && Number(f?.status) === 1
      )
    );
  };

  const handleCloseGuiaPlanBlockModal = () => {
    pushDataLayer("guia_aplicacao_historico_block_modal_close", {
      source: "historico",
      plan_id: guiaPlanBlockInfo?.planId ?? null,
      plan_name: guiaPlanBlockInfo?.planName ?? "",
    });

    setShowModalGuiaPlanBlock(false);
  };

  const handleGuiaPlanBlockUpgradeClick = () => {
    pushDataLayer("guia_aplicacao_historico_block_modal_upgrade_click", {
      source: "historico",
      plan_id: guiaPlanBlockInfo?.planId ?? null,
      plan_name: guiaPlanBlockInfo?.planName ?? "",
    });

    setShowModalGuiaPlanBlock(false);
  };

  const openPlanosFromGuiaPlanBlock = () => {
    handleGuiaPlanBlockUpgradeClick();
    props.history.push("/planos");
  };

  const handleOpenGuiaFromHistory = (receitaId) => {
    const user = getUserFromStorage();
    const planId = user?.contrato?.agro_plan_config?.agro_plan_id ?? null;
    const planName = user?.contrato?.agro_plan_config?.nome_plano ?? "";

    const allowed = canUseGuiaAplicacao(user);

    pushDataLayer("guia_aplicacao_historico_click", {
      source: "historico",
      receita_id: receitaId,
      allowed,
      plan_id: planId,
      plan_name: planName,
    });

    if (!allowed) {
      setGuiaPlanBlockInfo({ planId, planName });

      pushDataLayer("guia_aplicacao_historico_block_modal_view", {
        source: "historico",
        plan_id: planId,
        plan_name: planName,
      });

      setShowModalGuiaPlanBlock(true);
      return;
    }

    setSelectedReceitaGuia(receitaId);
    setShowModalGuide(true);
  };

  const openPlanos = () => {
    setShowModalBlock(false);
    props.history.push("/planos");
  };

  useEffect(() => {
    getHistory();
  }, [limit, offset, selectedFilters, startDateFilter, endDateFilter, searchTerm]);

  useEffect(() => {
    getAplicadores();
  }, []);

  useEffect(() => {
    setSelectedPrescriptionId(selectedReceitaGuia);
  }, [selectedReceitaGuia]);

  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredHistory(history);
    } else {
      const searchLower = removeAccents(searchTerm);
      const filtered = history.filter(
        (item) =>
          (item.numero &&
            removeAccents(item.numero.toString()).includes(searchLower)) ||
          (item.nome_comercial &&
            item.nome_comercial.some(
              (produto) =>
                produto && removeAccents(produto).includes(searchLower)
            )) ||
          (item.agronomo_nome &&
            removeAccents(item.agronomo_nome).includes(searchLower)) ||
          (item.produtor_nome &&
            removeAccents(item.produtor_nome).includes(searchLower)) ||
          (item.cultura_nome_comum &&
            removeAccents(item.cultura_nome_comum).includes(searchLower)) ||
          (item.fabricante &&
            item.fabricante.some(
              (empresa) =>
                empresa && removeAccents(empresa).includes(searchLower)
            )) ||
          (item.local_aplicacao_nome &&
            removeAccents(item.local_aplicacao_nome).includes(searchLower)) ||
          (item.praga_nome_comum &&
            item.praga_nome_comum.some(
              (praga) => praga && removeAccents(praga).includes(searchLower)
            ))
      );
      setFilteredHistory(filtered);
    }
  }, [searchTerm, history]);

  const [width, setWidth] = useState(window.innerWidth);
  const [showFilters, setShowFilters] = useState(false);

  const isShowFilters = () => {
    if (showFilters === true) {
      setShowFilters(false);
    } else {
      setShowFilters(true);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const clearSearch = () => {
    setSearchTerm("");
  };

  useEffect(() => {
    console.log("isAccordionOpen", isAccordionOpen);
  }, [isAccordionOpen]);

  useEffect(() => {
    getHistory();
  }, [limit, offset, selectedFilters, startDateFilter, endDateFilter, searchTerm]);

  useEffect(() => {
    getFilters();
  }, [selectedFilters, startDateFilter, endDateFilter, searchTerm]);

  useEffect(() => {
    if (isAccordionOpen && !hasExportOptions) {
      setAccordionOpen(false);
    }
  }, [isAccordionOpen, hasExportOptions]);

  return (
    <S.Container>
      <HeaderV2 title="Histórico" />

      <S.ContainerSearchBody>
        <S.SearchBody>
          {width > 768 && (
            <FilterHistory
              history={filters}
              onChange={handleSelectedFiltersChange}
              startDateValue={startDateFilter}
              endDateValue={endDateFilter}
              isLoading={filtersLoading}
              initialSelectedOptions={presetArtFilter || {}}
            >
              <S.ContainerFilterChindren>
                <InputV3
                  id="datetime-start"
                  type="date"
                  label="Selecione Data de início"
                  floatingLabelWithAsterisk="Data de início"
                  value={startDateFilter}
                  min="2000-01-01"
                  max="2100-12-31"
                  onChange={(e) => {
                    setStartDateFilter(e.target.value);
                  }}
                  handleClear={() => {
                    setStartDateFilter("");
                  }}
                />

                <InputV3
                  id="datetime-end"
                  type="date"
                  label="Selecione Data de término"
                  floatingLabelWithAsterisk="Data de término"
                  value={endDateFilter}
                  min="2000-01-01"
                  max="2100-12-31"
                  onChange={(e) => {
                    setEndDateFilter(e.target.value);
                  }}
                  handleClear={() => {
                    setEndDateFilter("");
                  }}
                />
              </S.ContainerFilterChindren>
            </FilterHistory>
          )}

          <div className="listContainer">
            <S.SearchHistoryArea>
              <div
                style={{
                  gap: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Search
                  placeholder="Número da Receita, Nome do Produto, etc"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  onClear={() => clearSearch()}
                />
                {width < 768 && (
                  <img
                    style={{ width: "20px" }}
                    src={Filter}
                    onClick={() => isShowFilters()}
                  ></img>
                )}
              </div>

              
            </S.SearchHistoryArea>

            {loadHistory ? (
              <S.ContainerLoading>
                <S.Loading />
              </S.ContainerLoading>
            ) : (
              <>
                <HistoryList
                  history={history}
                  onOpenGuia={handleOpenGuiaFromHistory}
                  updateReceitas={() => getHistory({ force: true })}
                />
              </>
            )}

            {!loadHistory && total > 0 && (
              <>
                <PaginatorV2
                  perPage={limit}
                  total={total}
                  currentPage={limit > 0 ? Math.floor(offset / limit) + 1 : 1}
                  onChange={(limit, offset) => updateLimitOffset(limit, offset)}
                  totalItens={history.length}
                />
              </>
            )}

            {!loadHistory && history.length === 0 && (
              <S.ContainerItemNotFound>
                <img src={ItemNotFound} alt="" />

                <H6 color={theme.colors.gray.Cinza_2}>
                  Nenhum item encontrado!
                </H6>
              </S.ContainerItemNotFound>
            )}
          </div>
        </S.SearchBody>
      </S.ContainerSearchBody>

      {showModalGuide && (
        <ModalAlert
          show={showModalGuide}
          onHide={() => setShowModalGuide(false)}
          size="md"
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <h4>Imprimir Guia de Aplicação</h4>

            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
                gap: "1rem",
                marginTop: "1rem",
              }}
            >
              <div
                style={{ display: "flex", width: "100%", alignItems: "center" }}
              >
                <InputV3
                  id="aplicador"
                  type="select"
                  label="Aplicador"
                  typeValueSelect="number"
                  floatingLabelWithAsterisk="Aplicador"
                  placeholder="Selecione um Aplicador"
                  value={selectedAplicador}
                  onChange={(val) => setSelectedAplicador(val)}
                  options={aplicadorOptions}
                  hasError={false}
                  errorInfo={""}
                />

                <TaglineM
                  color={theme.colors.blue.Azul_link}
                  cursor="pointer"
                  onClick={() => setAddAplicador(true)}
                >
                  Adicionar Aplicador
                </TaglineM>
              </div>

              <div
                style={{ display: "flex", width: "100%", alignItems: "center" }}
              >
                <InputV3
                  id="prestador"
                  type="select"
                  label="Prestador"
                  typeValueSelect="number"
                  floatingLabelWithAsterisk="Prestador"
                  placeholder="Selecione um Prestador"
                  value={selectedPrestador}
                  onChange={(val) => setSelectedPrestador(val)}
                  options={prestadorOptions}
                  hasError={false}
                  errorInfo={""}
                />
                <TaglineM
                  color={theme.colors.blue.Azul_link}
                  cursor="pointer"
                  onClick={() => setAddPrestador(true)}
                >
                  Adicionar Prestador
                </TaglineM>
              </div>
            </div>

            <S.Data>
              <div className="input-data-filter">
                <input
                  className="input-date"
                  type="text"
                  placeholder="Data de aplicação"
                  onFocus={(e) => (e.currentTarget.type = "date")}
                  onBlur={(e) => {
                    e.currentTarget.type = "text";
                    e.currentTarget.placeholder = "Data de aplicação";
                  }}
                  onChange={(e) => setDataAplicacao(e.target.value)}
                />
              </div>
            </S.Data>

            <div style={{ width: "48%", height: "3.125rem" }}>
              <Button
                value="Enviar"
                onClick={() => {
                  criarGuiaAplicacao();
                }}
              />
            </div>
          </div>
        </ModalAlert>
      )}

      {addAplicador && (
        <ModalAlert
          show={addAplicador}
          onHide={() => setAddAplicador(false)}
          size="md"
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <h4>Adicionar Aplicador</h4>
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
                gap: "1rem",
                marginTop: "1rem",
              }}
            >
              <InputV3
                id="aplicador"
                type="text"
                label="Nome do Aplicador"
                floatingLabelWithAsterisk="Nome do Aplicador"
                placeholder="Nome do Aplicador"
                value={newNameAplicador}
                onChange={(val) =>
                  setNewNameAplicador(val?.target?.value || "")
                }
                hasError={aplicadorError}
                errorInfo={"Campo obrigatório!"}
              />

              <InputV3
                id="aplicador"
                type="text"
                label="CPF do Aplicador"
                floatingLabelWithAsterisk="CPF do Aplicador"
                placeholder="CPF do Aplicador"
                value={newCPFAplicador}
                onChange={(val) => ValidateAplicador(val.target?.value || "")}
                onBlur={handleBlurAplicadorCpf}
                onKeyPress={(e) => {
                  const numericValue = newCPFAplicador.replace(/\D/g, "");
                  const isDigit = /\d/.test(e.key);

                  if (!isDigit || numericValue.length >= 11) {
                    e.preventDefault(); // bloqueia se não for número ou se já tiver 11 dígitos
                  }
                }}
                onPaste={(e) => {
                  e.preventDefault(); // bloqueia colar direto
                  const pasted = e.clipboardData.getData("Text");
                  const numeric = pasted.replace(/\D/g, "").slice(0, 11);
                  const formatted = formatCPF(numeric);
                  setNewCPFAplicador(formatted);
                }}
                hasError={aplicadorError}
                errorInfo={aplicadorErrorMsg}
              />
            </div>

            <div style={{ width: "48%", height: "3.125rem" }}>
              <Button
                value="Enviar"
                onClick={() =>
                  handleAddAplicador(newNameAplicador, newCPFAplicador)
                }
              />
            </div>
          </div>
        </ModalAlert>
      )}

      {addPrestador && (
        <ModalAlert
          show={addPrestador}
          onHide={() => setAddPrestador(false)}
          size="md"
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <h4>Adicionar Prestador</h4>
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
                gap: "1rem",
                marginTop: "1rem",
              }}
            >
              <InputV3
                id="razaoSocial"
                type="text"
                label="Razão Social"
                floatingLabelWithAsterisk="Razão Social"
                placeholder="Razão Social"
                value={newNamePrestador}
                onChange={(val) =>
                  setNewNamePrestador(val?.target?.value || "")
                }
                hasError={prestadorError}
                errorInfo={"Campo obrigatório!"}
              />

              <InputV3
                id="cnpj"
                type="text"
                label="CNPJ"
                floatingLabelWithAsterisk="CNPJ"
                placeholder="CNPJ do Prestador"
                value={newCNPJPrestador}
                onChange={(val) => ValidatePrestador(val?.target?.value || "")}
                onBlur={handleBlurPrestadorCnpj}
                onKeyPress={(e) => {
                  const numeric = newCNPJPrestador.replace(/\D/g, "");
                  const isDigit = /\d/.test(e.key);

                  if (!isDigit || numeric.length >= 14) {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const pasted = e.clipboardData.getData("Text");
                  const numeric = pasted.replace(/\D/g, "").slice(0, 14);
                  const formatted = formatCNPJ(numeric);
                  setNewCNPJPrestador(formatted);
                }}
                hasError={prestadorError}
                errorInfo={prestadorErrorMsg}
              />
            </div>

            <div style={{ width: "48%", height: "3.125rem" }}>
              <Button
                value="Enviar"
                onClick={() =>
                  handleAddPrestador(newNamePrestador, newCNPJPrestador)
                }
              />
            </div>
          </div>
        </ModalAlert>
      )}

      <Modal
        show={showFilters}
        size="sm"
        onHide={() => {
          setShowFilters(false);
        }}
      >
        <FilterHistory
          history={filters}
          onChange={handleSelectedFiltersChange}
          startDateValue={startDateFilter}
          endDateValue={endDateFilter}
          initialSelectedOptions={presetArtFilter || {}}
        >
          <S.ContainerFilterChindren>
            <InputV3
              id="datetime-start"
              type="date"
              label="Selecione Data de início"
              floatingLabelWithAsterisk="Data de início"
              value={startDateFilter}
              min="2000-01-01"
              max="2100-12-31"
              onChange={(e) => {
                setStartDateFilter(e.target.value);
              }}
              handleClear={() => {
                setStartDateFilter("");
              }}
            />

            <InputV3
              id="datetime-end"
              type="date"
              label="Selecione Data de término"
              floatingLabelWithAsterisk="Data de término"
              value={endDateFilter}
              min="2000-01-01"
              max="2100-12-31"
              onChange={(e) => {
                setEndDateFilter(e.target.value);
              }}
              handleClear={() => {
                setEndDateFilter("");
              }}
            />
          </S.ContainerFilterChindren>
        </FilterHistory>
      </Modal>

      {openModalExport === true ? (
        <ModalExportar
          show={openModalExport}
          onHide={() => setOpenModalExport(false)}
          resposta=""
          update={updateRespostaExportar}
          closeModal={() => setOpenModalExport(false)}
          title="Exportar dados - "
          option={optionTitle}
          optionValue={optionValue}
          setFilter={filtroState}
        ></ModalExportar>
      ) : null}

      <ModalAlert show={showModalGuiaPlanBlock} onHide={handleCloseGuiaPlanBlockModal}>
        <S.ModalPlanBlockContainer>
          <img src={ModalImageRecursoCliente} alt='Celular com formulário' />

          <H5 color={theme.colors.gray.Cinza_5}>Recurso exclusivo para clientes PRO</H5>

          <BodyG color={theme.colors.gray.Cinza_5}>
            Esta função está disponível apenas para clientes PRO. Para desbloquear essa
            e outras funcionalidades, faça já seu upgrade.
          </BodyG>

          <Auxiliar color={theme.colors.gray.Cinza_6}>
            Assine para ter Receitas Agronômicas atualizadas, Envio para Defesas,
            Controle de ART/TRT, Emissão de FISPQ/FDS/Ficha de Emergência, Relatórios e mais.
          </Auxiliar>

          <S.ModalPlanBlockButtonPlans>
            <Button
              width='296px'
              height='50px'
              value='VER PLANOS'
              outline={false}
              disabled={false}
              onClick={openPlanosFromGuiaPlanBlock}
              loading={false}
            />
          </S.ModalPlanBlockButtonPlans>
        </S.ModalPlanBlockContainer>
      </ModalAlert>

      <ModalAlert show={showModalBlock} onHide={() => setShowModalBlock(false)}>
        <h4
          style={{
            textAlign: "center",
          }}
        >
          Essa é uma função exclusiva para clientes AgroReceita
        </h4>

        <p
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          Para não comprometer o controle de suas receitas agronômicas durante o
          período de teste esta função é bloqueada.
        </p>

        <p
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          Assine o AgroReceita para desbloquear esta função!
        </p>

        <div
          className="button-finish"
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: "40px",
          }}
        >
          <Button
            width="296px"
            height="50px"
            value="VER PLANOS"
            outline={false}
            disabled={false}
            onClick={() => openPlanos(false)}
            loading={false}
          />
        </div>
      </ModalAlert>

      <ModalAlert
          width="500px"
          show={showModalNotification}
          onHide={() => setShowModalNotification(false)}
      >
          <h4 style={{
              textAlign: 'center'
          }}>Aviso:</h4>

          <p style={{
              textAlign: 'center',
              marginTop: '20px',
          }}>
              A partir agora o AgroReceita vai permitir o envio de Receitas para o SIDAGO e o SIAGRO DF sem informações da NF, conforme <a href="https://www.nfe.fazenda.gov.br/portal/exibirArquivo.aspx?conteudo=7fsG1qp0vrU= ">nota técnica 2024.003</a> os receituários agronômicos devem ser emitidos antes da NF. Por conta disso, você poderá enviar os dados da NF em até 7 dias após a data de emissão do receituário
          </p>

          <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px' }}>
              <Button
                  width='296px'
                  height='50px'
                  value='ENTENDI'
                  outline={false}
                  disabled={false}
                  onClick={() => setShowModalNotification(false)}
                  loading={false}
              />
          </div>
      </ModalAlert>

      <ModalAlert
        width="500px"
        show={showModalNotificationMG}
        onHide={() => setShowModalNotificationMG(false)}
      >
        <h4 style={{ textAlign: "center" }}>Aviso:</h4>

        <p
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          A partir de agora, o AgroReceita permitirá a geração do relatório de comercialização para o SICCA MG com as informações da NF, conforme a <a href="https://www.nfe.fazenda.gov.br/portal/exibirArquivo.aspx?conteudo=7fsG1qp0vrU= ">Nota Técnica 2024.003</a>.
          <br />
          Os receituários agronômicos devem ser emitidos antes da nota fiscal e, somente após isso, você poderá preencher os dados da NF no sistema.
        </p>

        <div
          className="button-finish"
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: "40px",
          }}
        >
          <Button
            width="296px"
            height="50px"
            value="ENTENDI"
            outline={false}
            disabled={false}
            onClick={() => setShowModalNotificationMG(false)}
            loading={false}
          />
        </div>
      </ModalAlert>
    </S.Container>
  );
};

export default Historico;
